export class FiltrosMarketing2{
   
    
    Ruc : string ='0';
    FechaIni : string = '';
    FechaFin : string = '';
    

 }